import axios from "axios";
import { API_URL } from "../../constants";

export default {
  getAllRole: () => {
    return axios.get(API_URL.ROLE, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },
  getAllRoleChart: () => {
    return axios.get(API_URL.ROLE_MENU_MAP, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },
  createRole: (data) => {
    return axios.post(API_URL.ROLE, data, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },
  roleMap: (data) => {
    return axios.post(API_URL.ROLE_MAP, data, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },
};
